import React from "react";
import { Link } from "react-router-dom";
import polarisLogo from "../images/Polaris Logo.svg";
import NewsletterSignup from "./NewsletterSignup";
import FooterSocialLinks from "./FooterSocialLinks";
import "../styles/landing-page.css";

export default function PublicFooter() {
    return (
        <footer className="landing-footer">
            <div className="landing-footer-grid">
                <div className="landing-footer-brand">
                    <img src={polarisLogo} alt="Polaris Athlete" className="landing-footer-logo" />
                    <p className="landing-footer-tagline">College Counseling x NIL Education. Connected.</p>
                    <NewsletterSignup />
                    <FooterSocialLinks />
                </div>
                <div className="landing-footer-col">
                    <h4 className="landing-footer-col-heading">Quick Links</h4>
                    <ul className="landing-footer-links">
                        <li><Link to="/about" className="landing-footer-link">About</Link></li>
                        <li><Link to="/our-team" className="landing-footer-link">Our Team</Link></li>
                        <li><Link to="/schools" className="landing-footer-link">Solutions</Link></li>
                        <li><Link to="/blogs" className="landing-footer-link">Blog</Link></li>
                        <li><Link to="/signup" className="landing-footer-link">Plans</Link></li>
                        <li><Link to="/contact" className="landing-footer-link">Contact</Link></li>
                    </ul>
                </div>
                <div className="landing-footer-col">
                    <h4 className="landing-footer-col-heading">Contact</h4>
                    <ul className="landing-footer-links landing-footer-contact-list">
                        <li className="landing-footer-contact-item">
                            <span className="landing-footer-contact-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                    <circle cx="12" cy="10" r="3" />
                                </svg>
                            </span>
                            <span className="landing-footer-link">Austin, Texas</span>
                        </li>
                        <li className="landing-footer-contact-item">
                            <span className="landing-footer-contact-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="2" y="4" width="20" height="16" rx="2" />
                                    <path d="m22 6-10 7L2 6" />
                                </svg>
                            </span>
                            <a href="mailto:info@polarisathlete.com" className="landing-footer-link">
                                info@polarisathlete.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="landing-footer-bottom">
                <span className="landing-footer-copyright">
                    &copy; Polaris Athlete LLC 2026 | All Rights Reserved
                </span>
                <div className="landing-footer-legal">
                    <Link to="/privacy" className="landing-footer-link">Privacy Policy</Link>
                    <span className="landing-footer-sep">|</span>
                    <Link to="/terms" className="landing-footer-link">Terms &amp; Conditions</Link>
                    <span className="landing-footer-sep">|</span>
                    <Link to="/data" className="landing-footer-link">Data &amp; Account Deletion</Link>
                </div>
            </div>
        </footer>
    );
}
